import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

const aZureTicketURL= environment.azureTicketApiUrl;

@Injectable({
  providedIn: 'root'
})
export class ContactSupportService {
  projectName = 'iAR-Service';

  constructor(private http: HttpClient, private router: Router) { }

  getWorkItems(clientName, projectName){
    return this.http.get(aZureTicketURL + 'WorkItems/GetWorkItems/' + clientName + '/' + projectName);
  }

  createWorkItems(dataobj){
    return this.http.post(aZureTicketURL + 'WorkItems/CreateWorkItemWithAttachment', dataobj);
  }

  getAttachment(workItemId, projectName): Observable<any>{
    return this.http.get(aZureTicketURL + 'WorkItems/GetAttachment/' + workItemId + '/' + projectName, {  observe: 'response' });
  }
}
